import React from "react";

function JobInfo(props) {
    const { title, header, content, AboutWorktitle, AboutWorkItems, AboutYoutitle, AboutYouItems } = props.data;
    const mainContent = props.content;

    return (
        <div className="job-info section-gap">
            <div className="section-gap">
                <div className="container">
                    <p className="theme-color-title">{title}</p>
                    <div className="job-details" dangerouslySetInnerHTML={{ __html: mainContent }}></div>
                    {/* <div className="" onClick={() => { scrollTo('#form-section'); }}><a className="button apply-btn" title="Apply for job">Apply for this job</a></div> */}
                </div>
            </div>
        </div>
    );
};

export default JobInfo;